import { Decoration } from '@atlaskit/editor-prosemirror/view';
var containerStyle = "\n\tposition: relative;\n";
var caretStyle = "\n\tposition: absolute;\n\theight: 100%;\n\twidth: 1px;\n\tleft: -0.5px;\n\tbottom: 0;\n\tbackground-color: ".concat("var(--ds-text, #172B4D)", ";\n");
var toDOM = function toDOM() {
  var _caret$animate;
  var container = document.createElement('span');
  container.className = 'ProseMirror-mark-boundary-cursor';
  container.setAttribute('style', containerStyle);
  var caret = document.createElement('div');
  caret.setAttribute('style', caretStyle);
  (_caret$animate = caret.animate) === null || _caret$animate === void 0 || _caret$animate.call(caret, [{
    opacity: 1
  }, {
    opacity: 1,
    offset: 0.5
  }, {
    opacity: 0,
    offset: 0.5
  }, {
    opacity: 0
  }], {
    duration: 1000,
    iterations: Infinity
  });
  container.appendChild(caret);
  return container;
};
export var createMarkBoundaryCursorDecoration = function createMarkBoundaryCursorDecoration(pos, side) {
  return Decoration.widget(pos, toDOM, {
    key: 'mark-boundary-cursor',
    side: side
  });
};